export default {
    egateeUserCenter: "Centro de usuários Egatee",
    mayTheForceBeWithU: "Que a força esteja com você",
    egatee: "Egatee",
    jde: "Jde",
    egateeShopCenter: "Centro comercial do Egatee",
    egateeGlobalCommandCenter: "Centro do comando global do Egatee",
    egateeCountrySite: "Localização do Egatee no país",
    shopCenter: "Centro de compras",
    globalCommandCenter: "Centro de Comando Global",
    countrySite: "Local no país",
    suppliersSettled: "Loja liquidada",
    supplierInformation: "Informações da loja",
    subjectInformation: "Informações do Assunto",
    mmdc: "Corporação de Multimédia Digital",
    mmdc_title: "Dados-MMDC"
}